import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import { Item, Content, Info, Label, Editor } from '../Item';
import styles from './Documents.m.sass';
import { answerToString } from '../../../../utils/questionUtil';
import TickmarkIcon from './tickmark.i.svg';
var Documents = function Documents(_ref) {
  var question = _ref.question,
    answer = _ref.answer,
    readOnly = _ref.readOnly,
    onChange = _ref.onChange,
    onUpdate = _ref.onUpdate,
    disabled = _ref.disabled,
    checkout = _ref.checkout;
  return /*#__PURE__*/React.createElement(Item, {
    checkout: checkout,
    title: question.description
  }, /*#__PURE__*/React.createElement(Content, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Info, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Label, {
    checkout: checkout
  }, question.question)), /*#__PURE__*/React.createElement(Editor, {
    checkout: checkout
  }, readOnly ? /*#__PURE__*/React.createElement("div", {
    className: styles.response
  }, answerToString(question, answer)) : /*#__PURE__*/React.createElement("div", {
    className: styles.response
  }, question.options.map(function (opt, i) {
    return /*#__PURE__*/React.createElement(DocumentOption, {
      question: question,
      answer: answer,
      option: opt,
      key: i
    });
  })))));
};
export default observer(Documents);
var DocumentOption = function DocumentOption(_ref2) {
  var option = _ref2.option,
    question = _ref2.question,
    answer = _ref2.answer;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.option
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.icon, !documentIsProvided(question, answer, option) && styles.hidden)
  }, /*#__PURE__*/React.createElement(TickmarkIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, option.text));
};
function documentIsProvided(question, answer, option) {
  return Array.isArray(answer) && answer.some(function (a) {
    return a.id === option.id;
  });
}
//# sourceMappingURL=index.js.map
